const domainMap = {
    data: {
        domestic: {
            daily: '//datahub.daily.taobao.net',
            pre: '//pre-data-wms.cainiao.com',
            pro: '//data-wms.cainiao.com',
        },
        sg: {
            pre: '//pre-wmsdatahub.sg.cainiao.com',
            pro: '//datahub.sg.cainiao.com',
        },
    },
};
export const domain = {
    domainMap,
    country: 'domestic',
    /**
     * 解析当前域名是什么环境
     * @param {*} domain
     */
    parseEnv(domainName) {
        // 环境, 默认为线上环境
        // HTTPS的线上环境也解析为HTTP环境
        let env = 'pro';
        // data-express 会命中 pre， 现调整为pre-
        if (domainName.indexOf('pre-') >= 0 ||
            domainName.indexOf('stg.') >= 0 ||
            domainName.indexOf('stg-') >= 0) {
            env = 'pre';
        }
        else if (domainName.indexOf('taobao.net') >= 0 ||
            domainName.indexOf('cainiao.test') >= 0) {
            // 解决某些日常的域名没有是taobao.net没有daily的问题 by xpp
            env = 'daily';
        }
        return env;
    },
    setCountry(country) {
        this.country = country;
    },
    /**
     * 设置domain
     * @param {*} moduleName 模块名称
     * @param {*} domainName
     */
    setDomain(moduleName, domainName) {
        this.domainMap[moduleName] = domainName;
    },
    getDomain(moduleName) {
        const env = this.parseEnv(window.location.host);
        return this.getHost(moduleName, env);
    },
    getHost(CODE, ENV) {
        const env = ENV || 'pro';
        if (this.domainMap[CODE]) {
            return this.domainMap[CODE][this.country][env] || '';
        }
        if (CODE === undefined) {
            return window.location.host;
        }
        return '';
    },
};
